/**
 * Safe display strings for header / avatars when first_name / last_name are missing.
 */

export function getUserDisplayLabel(user) {
  if (!user) {
    return '';
  }
  if (user.name && String(user.name).trim()) {
    return String(user.name).trim();
  }
  const first = (user.first_name || '').trim();
  const last = (user.last_name || '').trim();
  return [first, last].filter(Boolean).join(' ').trim();
}

export function getUserInitials(user) {
  if (!user) {
    return '';
  }
  const first = (user.first_name || '').trim();
  const last = (user.last_name || '').trim();
  if (first || last) {
    return (first.charAt(0) + last.charAt(0)).toUpperCase();
  }
  const name = (user.name || '').trim();
  if (name.length >= 2) {
    return name.substr(0, 2).toUpperCase();
  }
  if (name.length === 1) {
    return name.toUpperCase();
  }
  return '?';
}



// WEBPACK FOOTER //
// ./src/helpers/user/userDisplay.js